"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRegion = void 0;
const ca_state_region_1 = __importDefault(require("./ca-state-region"));
const us_state_region_1 = __importDefault(require("./us-state-region"));
function getRegion(country, state) {
    switch (country.toUpperCase()) {
        case 'US':
            return us_state_region_1.default[state];
        case 'CA':
            return ca_state_region_1.default[state];
        case 'MX':
            return 'Mexico';
        default:
            return 'International';
    }
}
exports.getRegion = getRegion;
